function safeReturnPath(value: unknown): string {
  return typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//")
    ? value
    : "/";
}

export function validateLoginSearch(search: Record<string, unknown>) {
  return {
    redirect: safeReturnPath(search.redirect),
    ...(search.expired === true || search.expired === "true"
      ? { expired: true }
      : {}),
  };
}
